import { Injectable }                         from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IngInputBase, IngSelectChild }       from './inputs';

@Injectable()
export class DynamicFormService {
  constructor() { }

  toGroup(inputs: IngInputBase<any>[]) {
    let group: any = {};

    inputs
      .sort((a, b) => { return a.order - b.order })
      .forEach(input => {
        group[input.key] = input.required ? new FormControl(input.value || '', Validators.required)
                                          : new FormControl(input.value || '');

        if(!!input['child']) {
          let child: IngSelectChild = input['child'];

          group[child.key] = child.required ? new FormControl(child.value || '', Validators.required)
                                            : new FormControl(child.value || '');
        }
      });

    return new FormGroup(group);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form.service.ts